<form nz-form [formGroup]="form">
    <!-- <nz-form-item>
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{'Common.Name' | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="getNameErrorTpl">
            <input nz-input formControlName="name" [maxlength]="100">
            <ng-template #getNameErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required') || control.hasError('emptyString')">
                    名称不能为空
                </ng-container>
                <ng-container *ngIf="control.hasError('maxlength')">
                    长度不能超过{{max100Length}}个字符
                </ng-container>
            </ng-template>
        </nz-form-control>
    </nz-form-item> -->

    <nz-form-item>
        <nz-form-label [nzFlex]="size.label">
            {{'Common.Name' | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control">
            <wx-localized-text-input formControlName="name"></wx-localized-text-input>

        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label [nzFlex]="size.label">
            {{'Common.Description' | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="getDescriptionErrorTpl">
            <textarea nz-input formControlName="description" [rows]="3" [maxlength]="500"></textarea>
            <ng-template #getDescriptionErrorTpl let-control>
                <ng-container *ngIf="control.hasError('maxlength')">
                    长度不能超过{{max500Length}}个字符
                </ng-container>
            </ng-template>
        </nz-form-control>
    </nz-form-item>
</form>
<div *nzModalFooter>
    <button (click)="cancel()" nz-button>{{'Common.Cancel' | translate}}</button>
    <button (click)="save()" nz-button nzType="primary">{{'Common.Confirm' | translate}}</button>
</div>